import {
  UPDATECUSTOMERDETAILS_SUCCESS,
  UPDATECUSTOMERDETAILS_FAILED,
  RESET_UPDATECUSTOMERDETAILS,
  LOADING_UPDATECUSTOMERDETAILS,
  NETWORK_ERROR_UPDATECUSTOMERDETAILS,
} from "../types/index";

const initialState = {
  isLoading: false,
  success: false,
  network: false,
  failed: false,
  data: {},
  message: "",
  networkError: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_UPDATECUSTOMERDETAILS:
      return {
        ...state,
        isLoading: true,
        success: false,
        failed: false,
        network: false,
        data: {},
        message: "",
        networkError: "",
      };
    case UPDATECUSTOMERDETAILS_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: true,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case UPDATECUSTOMERDETAILS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        success: true,
        failed: false,
        network: false,
        data: action.payload,
        message: "",
        networkError: "",
      };
    case NETWORK_ERROR_UPDATECUSTOMERDETAILS:
      return {
        ...state,
        isLoading: false,
        success: false,
        failed: false,
        network: true,
        data: {},
        message: "",
        networkError: "",
      };
    case RESET_UPDATECUSTOMERDETAILS:
      return (state = initialState);
    default:
      return state;
  }
};
